<template>


    <div class="lgx-split">

        <!-- Panneau gauche (image + pitch) : desktop uniquement -->
        <aside class="lgx-side">
            <div class="lgx-logo-w"><img src="@/assets/logo.png" alt="HSIGCOM"></div>
            <div class="lgx-pitch">
                <h2>Toute votre activité commerciale, maîtrisée et normalisée.</h2>
                <p>De l'achat à la vente, pilotez vos clients, votre stock et votre comptabilité en temps réel, avec des factures normalisées conformes à la DGI, générées en un clic.</p>
                <p class="lgx-sectors"><i class="ri-store-3-line"></i> Boulangerie, poissonnerie, restaurant, bar, supermarché… un seul outil pour tous vos points de vente.</p>
                <div class="lgx-feats">
                    <div class="lgx-feat"><i class="ri-shopping-cart-2-line"></i> Achats &amp; ventes pilotés au quotidien</div>
                    <div class="lgx-feat"><i class="ri-shield-check-line"></i> Facturation normalisée DGI en un clic</div>
                    <div class="lgx-feat"><i class="ri-calculator-line"></i> Comptabilité tenue automatiquement</div>
                    <div class="lgx-feat"><i class="ri-group-line"></i> Clients suivis et fidélisés</div>
                    <div class="lgx-feat"><i class="ri-archive-line"></i> Stock maîtrisé en temps réel</div>
                </div>
            </div>
            <div class="lgx-copy">© HSIGCOM · Gestion commerciale</div>
        </aside>

        <!-- Zone formulaire -->
        <main class="lgx-main">
            <div class="lgx-card">

                <div class="lgx-card-logo"><img src="@/assets/logo.png" alt="HSIGCOM"></div>

                <div class="lgx-mpitch">
                    <p class="lgx-mtag">Ventes, stock et comptabilité, avec factures <strong>normalisées DGI</strong>.</p>
                    <p class="lgx-msectors"><i class="ri-store-3-line"></i> Boulangerie · restaurant · supermarché · bar…</p>
                </div>

                <h3 class="lgx-title">Connexion au compte</h3>
                <p class="lgx-sub">Renseignez vos identifiants pour accéder à votre espace.</p>

                <div class="lgx-form">

                    <div v-if="datamessageerror.length>0" class="lgx-alert">
                        <div class="lgx-alert-head"><i class="ri-error-warning-line"></i> Erreur</div>
                        <ul class="lgx-alert-list">
                            <li v-for="(message,index) in datamessageerror" :key="index">{{message}}</li>
                        </ul>
                    </div>

                    <div class="lgx-field">
                        <label for="societe">Société</label>
                        <div class="lgx-inp">
                            <i class="ri-building-line"></i>
                            <input type="text" v-model="items.societe" id="societe" autofocus placeholder="Nom de la société" @keyup.enter="seconnecter">
                        </div>
                    </div>

                    <div class="lgx-field">
                        <label for="login">Login</label>
                        <div class="lgx-inp">
                            <i class="ri-user-line"></i>
                            <input type="text" v-model="items.login" id="login" placeholder="Votre identifiant" @keyup.enter="seconnecter">
                        </div>
                    </div>

                    <div class="lgx-field">
                        <label for="password">Mot de passe</label>
                        <div class="lgx-inp">
                            <i class="ri-lock-2-line"></i>
                            <input type="password" v-model="items.password" id="password" placeholder="••••••••" @keyup.enter="seconnecter">
                        </div>
                    </div>

                    <div class="lgx-row">
                        <label class="lgx-check">
                            <input type="checkbox" v-model="items.remember" id="remember"> Se souvenir
                        </label>
                        <a href="#" class="lgx-link">Mot de passe oublié ?</a>
                    </div>

                    <button @click="seconnecter" type="button" class="lgx-btn">
                        <i class="ri-login-circle-line"></i> Se connecter
                    </button>

                    <p class="lgx-foot">Pas encore de dossier ? <a href="#">Commencer</a></p>







                </div>
            </div>
        </main>
    </div>

</template>

<script>
   // import allfunction from "@/allfunction";
    import {randomString} from "@/allfunction";
    import JwtService from "@/common/jwt.service";
    import templatesite from "@/components/template/apptemplate";
   import permissionservice from '@/service/directives/permissionService';
   import permissionHelper from "@/service/directives/permissionHelper";
   import {stockproduits} from "@/service/directives/vpermission";
    //import {setAuthorization} from "@/common/jwt.service";
    const axios =require('axios');

    export default {
        /* eslint-disable */
        name: "login",
        components: {
            templatesite
        },
        data() {
            return {
                items:{
                    societe:'',
                    login:'',
                    password:'',
                    remember:true,
                    socket: null,
                },
                allchurch:[],
                datamessageerror:[],
                messagesuccess:"",
            };
        },
        methods: {

            /*seconnecter(){
                if (this.items.password==='' || this.items.login===''){

                    this.presentToast("Veuillez saisir votre login et votre mot de passe")

                    return
                }

                this.$store.commit('isAuthenticated',{value:true});

                this.$router.push({path: '/'});

            },*/

            async  seconnecter(){
                this.datamessageerror=[];
                this.messagesuccess="";



                if (this.items.societe===''){

                    this.datamessageerror.push("Veuillez saisir la société.")

                }

                if (this.items.login===''){

                    this.datamessageerror.push("Veuillez saisir le login.")

                }

                if (this.items.password===''){

                    this.datamessageerror.push("Veuillez saisir le mot de passe.")

                }

                if (this.items.password.length<6){

                    this.datamessageerror.push("Le mot de passe doit être de 6 caractères minimum")

                }


                if ( this.datamessageerror.length>0){

                    return
                }


                this.$store.dispatch('lancerchargement',true)

                const t = this;

                t.$store.dispatch('lancerchargement',true)

                let response =   axios.post(process.env.VUE_APP_API_URL+'/login1478pojhgfderffg458755/'+randomString(),this.items,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ',
                        'csrftoken':''
                    },
                    withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })
                let res= await response
                    .then(function (res){

                       // t.$store.dispatch('lancerchargement',true)

                        if(res.data.success){


                            t.messagesuccess=res.data.message;

                            t.$store.dispatch('lancerchargement',false)


                            JwtService.setAuthorization(res.data.datas._actk);
                            t.$store.commit('isAuthenticated',{value:true});
                            t.$store.commit('appusername',{name:res.data.datas._nme});
                            t.$store.commit('approle',{name:res.data.datas._rl});
                            t.$store.commit('appuserpicture',{name:t.$store.state.baseurlapifile+res.data.datas._picture});
                            t.$store.commit('appsociete',{name:res.data.datas._utk});
                            t.$store.commit('authscango',{name:res.data.datas.authscango});
                            t.$store.commit('appserverdate',{name:res.data.datas.dateserv})

                            t.$store.commit('currentuserpermissions',{value:res.data.datas.flattenedpermissions})
                          
                            t.$store.commit('annexeuser',{value:res.data.datas.annexe})


                            //**********************************
 
                            t.$store.commit('listeallcaisses',{value:res.data.datas.allcaisse})
                             t.$store.commit('paramsapp',{value:res.data.datas.__sssysapp})

                            t.$store.commit('datanotification',{value:res.data.datas.__notif})
                            t.$store.commit('nbrenotification',{value:res.data.datas.__countnotif})

                            t.$store.commit('accescomponent',{value:res.data.datas.iujhi7855})
                            t.$store.commit('nbrepersautorise',{value:res.data.datas.__nbrpers})

                           // console.log("res.data.datas.__auth ************** ",res.data.datas.__auth)

                            t.$store.commit('authorizechangementprix',{value:res.data.datas.__auth.authorizechangementprix})
                            t.$store.commit('authorizesignatureelectronique',{value:res.data.datas.__auth.authorizesignatureelectronique})


                           // console.log("res.data.datas.__auth.authorizesignatureelectronique ************** ",res.data.datas.__auth.authorizesignatureelectronique)


                            t.$store.commit('authorizenormalisation',{value:res.data.datas.__auth.authorizenormalisation})
                            t.$store.commit('authorizeprix0',{value:res.data.datas.__auth.authorizeprix0})
                            t.$store.commit('authorizefacturactionpartiel',{value:res.data.datas.__auth.authorizefacturactionpartiel})

                            t.$store.commit('authorizefacturepourgenereranalyse',{value:res.data.datas.__auth.authorizefacturepourgenereranalyse})
                            t.$store.commit('allccessapp',{value:res.data.datas.iujhi7855})

                            const userPermissions =res.data.datas.flattenedpermissions
                                permissionservice.setUserPermissions(res.data.datas.flattenedpermissions);



                            //**************************************

                            t.$store.commit('etatlogo',{etatlogo:t.$store.state.baseurlapifile+res.data.datas.__etatinfo.etatlogo})

                            t.$store.commit('etatraisonsocial',{etatraisonsocial:res.data.datas.__etatinfo.etatraisonsocial})
                            t.$store.commit('etatifu',{etatifu:res.data.datas.__etatinfo.etatifu})
                            t.$store.commit('etatrccm',{etatrccm:res.data.datas.__etatinfo.etatrccm})
                            t.$store.commit('etattelephone',{etattelephone:res.data.datas.__etatinfo.etattelephone})
                            t.$store.commit('etatadresse',{etatadresse:res.data.datas.__etatinfo.etatadresse})

                            t.$store.commit('sysmodule',{value:res.data.datas.__module})
                            t.$store.commit('paramsystem',{value:res.data.datas.__sssys})

                            JwtService.setToken(res.data.datas._actk);
                            JwtService.setTokenUser(res.data.datas._nme);
                            JwtService.setTokenRole(res.data.datas._rl);

                            
                             t.$store.commit('appsocketroom',{name:t.items.societe})
                             t.$store.dispatch('initializeSocket').then(() => {
                                 console.log("initializeSocket a été appelé.");
                            });
                             t.$store.dispatch('joinsocketRoom',{room:t.items.societe}).then(() => {
                                 console.log("joinsocketRoom a été appelé.");
                            });

                             t.$store.dispatch('addDynamicListener',{event:"messageconnecte"})
                                .then((res) => {
                                    console.log("res ........... ",res);
                                });





                            let isloadallarticle=false
                            isloadallarticle=permissionHelper.check(stockproduits, userPermissions);

                            t.$store.dispatch('loadevoluationdata')


                            if (isloadallarticle){
                                t.$store.dispatch('loadlistedesarticles')
                                t.$store.dispatch('loadlisteotherdatacentredeconsommation_paramcom_magasin')
                            }






                            t.$router.push({name: 'acceuilpage'});

                        }
                        else{
                          //  t.datamessageerror=res.data.datamessage;
                            t.$store.dispatch('lancerchargement',false)
                            for (let message of res.data.datamessageerror){

                                t.datamessageerror.push(message)

                            }

                        }


                    })
                    .catch((error)=>{

                        this.$store.dispatch('lancerchargement',false)

                        }
                    )
                    .finally(() =>{

                        this.$store.dispatch('lancerchargement',false)

                    })




            },

        },
        mounted() {

          //  this.loaddata();
        }


    }
</script>

<style scoped>

    @import url("@/assets/css/tailwindv2_0_1.css");

    /* ===== Refonte login — charte marque HSIGCOM (vert #45B15E -> bleu #1C79AC) ===== */
    .lgx-split{
        --green:#45B15E; --green-strong:#2E9E56; --blue:#1C79AC;
        --ink:#0f172a; --muted:#64748b; --border:#e2e8f0;
        --grad:linear-gradient(135deg, #4FB06A 0%, #1C79AC 100%);
        display:flex; min-height:100vh; font-family:'Inter',system-ui,-apple-system,sans-serif;
    }
    .lgx-split *{box-sizing:border-box;}

    /* Panneau gauche (image + pitch) — desktop */
    .lgx-side{
        position:relative; flex:1 1 46%; overflow:hidden; display:flex; flex-direction:column;
        justify-content:space-between; padding:2.6rem; color:#fff; min-width:0;
    }
    .lgx-side::before{
        content:""; position:absolute; inset:0;
        background:url("@/assets/img/22.jpg") center/cover no-repeat; transform:scale(1.05);
    }
    .lgx-side::after{
        content:""; position:absolute; inset:0;
        background:linear-gradient(150deg, rgba(21,94,66,.92) 0%, rgba(28,121,172,.80) 60%, rgba(46,158,86,.55) 100%);
    }
    .lgx-side > *{position:relative; z-index:2;}
    .lgx-logo-w img{height:38px; filter:brightness(0) invert(1);}
    .lgx-pitch h2{font-size:1.9rem; font-weight:700; line-height:1.25; margin-bottom:.9rem;}
    .lgx-pitch p{font-size:.95rem; line-height:1.6; color:rgba(255,255,255,.85); max-width:420px;}
    .lgx-sectors{margin-top:1rem; font-size:.86rem; font-weight:500; color:#fff; display:flex; align-items:flex-start; gap:.5rem;}
    .lgx-sectors i{margin-top:.1rem; font-size:1.05rem; opacity:.9;}
    .lgx-feats{display:flex; flex-direction:column; gap:.7rem; margin-top:1.6rem;}
    .lgx-feat{display:flex; align-items:center; gap:.6rem; font-size:.9rem; color:rgba(255,255,255,.92);}
    .lgx-feat i{height:30px; width:30px; border-radius:8px; background:rgba(255,255,255,.16);
        display:flex; align-items:center; justify-content:center; font-size:1rem;}
    .lgx-copy{font-size:.78rem; color:rgba(255,255,255,.65);}

    /* Zone formulaire */
    .lgx-main{
        position:relative; overflow:hidden; flex:1 1 54%; display:flex; align-items:center; justify-content:center;
        padding:2.5rem; background:linear-gradient(160deg, #ffffff 0%, #eef3f7 100%); min-width:0;
    }
    .lgx-main::before{
        content:""; position:absolute; top:-140px; right:-110px; width:360px; height:360px; border-radius:50%;
        background:radial-gradient(circle at center, rgba(79,176,106,.20), transparent 68%); pointer-events:none;
    }
    .lgx-main::after{
        content:""; position:absolute; bottom:-160px; left:-120px; width:380px; height:380px; border-radius:50%;
        background:radial-gradient(circle at center, rgba(28,121,172,.16), transparent 68%); pointer-events:none;
    }
    .lgx-card{
        position:relative; z-index:1; width:100%; max-width:420px; background:#fff;
        border:1px solid #eef1f5; border-radius:20px; padding:2.6rem 2.4rem;
        box-shadow:0 24px 50px -24px rgba(15,23,42,.28), 0 6px 16px -8px rgba(15,23,42,.08);
    }
    .lgx-card-logo{display:none;}
    .lgx-card-logo img{height:52px;}
    .lgx-mpitch{display:none;}
    .lgx-title{font-size:1.5rem; font-weight:700; color:var(--ink); margin:0;}
    .lgx-sub{color:var(--muted); font-size:.9rem; margin:.3rem 0 1.6rem;}
    .lgx-form{display:flex; flex-direction:column;}
    .lgx-field{margin-bottom:1.05rem;}
    .lgx-field label{display:block; font-size:.78rem; font-weight:600; color:#475569; margin-bottom:.4rem;}
    .lgx-inp{position:relative; display:flex; align-items:center;}
    .lgx-inp i{position:absolute; left:.85rem; color:#94a3b8; font-size:1.05rem;}
    .lgx-inp input{
        width:100%; height:48px; padding:0 .9rem 0 2.6rem; border:1px solid var(--border);
        border-radius:12px; font-size:.92rem; color:var(--ink); background:#f8fafc; transition:all .2s;
    }
    .lgx-inp input::placeholder{color:#a3adba;}
    .lgx-inp input:focus{outline:none; border-color:var(--green); background:#fff; box-shadow:0 0 0 4px rgba(69,177,94,.16);}
    .lgx-inp input:focus + i, .lgx-inp:focus-within i{color:var(--green);}
    .lgx-row{display:flex; align-items:center; justify-content:space-between; margin:.2rem 0 1.5rem;}
    .lgx-check{display:flex; align-items:center; gap:.5rem; font-size:.82rem; color:#475569; cursor:pointer;}
    .lgx-check input{width:16px; height:16px; accent-color:var(--green);}
    .lgx-link{font-size:.82rem; color:var(--blue); text-decoration:none; font-weight:500;}
    .lgx-link:hover{text-decoration:underline;}
    .lgx-btn{
        width:100%; height:50px; border:none; border-radius:12px; cursor:pointer; background:var(--grad);
        color:#fff; font-size:.98rem; font-weight:600; display:flex; align-items:center; justify-content:center;
        gap:.5rem; box-shadow:0 14px 26px -10px rgba(28,121,172,.55); transition:transform .15s, box-shadow .15s;
    }
    .lgx-btn:hover{transform:translateY(-1px); box-shadow:0 18px 32px -10px rgba(28,121,172,.6);}
    .lgx-btn:active{transform:translateY(0);}
    .lgx-foot{margin-top:1.5rem; text-align:center; font-size:.78rem; color:#94a3b8;}
    .lgx-foot a{color:var(--green-strong); font-weight:600; text-decoration:none;}

    .lgx-alert{background:#fef2f2; border:1px solid #fecaca; border-radius:10px; padding:.7rem .9rem; margin-bottom:1.1rem;}
    .lgx-alert-head{display:flex; align-items:center; gap:.4rem; font-weight:600; font-size:.82rem; color:#b91c1c; margin-bottom:.25rem;}
    .lgx-alert-list{margin:0; padding-left:1.1rem; font-size:.78rem; color:#b91c1c; list-style:disc;}

    /* ===== MOBILE = Proposition A (fond plein + carte glass centrée) ===== */
    @media(max-width:820px){
        .lgx-side{display:none;}
        .lgx-split{position:relative; overflow:hidden;}
        .lgx-split::before{
            content:""; position:absolute; inset:0;
            background:url("@/assets/img/22.jpg") center/cover no-repeat; transform:scale(1.05); z-index:0;
        }
        .lgx-split::after{
            content:""; position:absolute; inset:0; z-index:1;
            background:radial-gradient(120% 90% at 15% 20%, rgba(46,158,86,.5), transparent 60%),
                       linear-gradient(120deg, rgba(15,23,42,.86) 0%, rgba(15,60,58,.74) 45%, rgba(28,121,172,.5) 100%);
        }
        .lgx-main{position:relative; z-index:2; background:transparent; padding:1.5rem;}
        .lgx-main::before, .lgx-main::after{display:none;}
        .lgx-card{
            max-width:430px; background:rgba(255,255,255,.90);
            -webkit-backdrop-filter:blur(12px); backdrop-filter:blur(12px);
            border:1px solid rgba(255,255,255,.55); border-radius:22px; padding:2.2rem 1.9rem;
            box-shadow:0 30px 60px -18px rgba(15,23,42,.55), 0 8px 20px -12px rgba(15,23,42,.35), inset 0 1px 0 rgba(255,255,255,.6);
        }
        .lgx-card-logo{display:flex; justify-content:center; margin-bottom:1rem;}
        .lgx-mpitch{display:block; text-align:center; margin-bottom:1.3rem;}
        .lgx-mtag{font-size:.9rem; line-height:1.45; color:#334155; margin:0 0 .45rem;}
        .lgx-mtag strong{color:var(--green-strong); font-weight:700;}
        .lgx-msectors{font-size:.78rem; color:var(--blue); font-weight:500; margin:0; display:inline-flex; align-items:center; gap:.35rem;}
        .lgx-title{font-size:1.25rem; text-align:center;}
        .lgx-sub{text-align:center;}
    }

</style>